import { execSync } from 'child_process';

export function readGitBranches(cwd: string) {
  const branches = execSync('git for-each-ref refs/heads', {
    cwd
  }).toString();
  return branches
    .split(/[\n\r]/)
    .filter(x => !!x)
    .map(x => x.split(/\s+/)[2])
    .map(r => {
      const q = r.split('/');
      return q[q.length - 1];
    });
}

//  eef053e906b4006d95e8af2c85a369fc79a2c481 commit    refs/heads/master
